import { PhoneSchema } from "@/utils/commonSchema";
import {
  boolean,
  email,
  literal,
  null_,
  nullable,
  number,
  object,
  objectAsync,
  optional,
  pipe,
  string,
  toLowerCase,
  transform,
  trim,
  union,
  unionAsync,
  variantAsync,
} from "valibot";

export const RequestProgramInputSchema = variantAsync("type", [
  objectAsync({
    type: literal("authenticated"),
    departureId: number(),
  }),
  objectAsync({
    type: literal("anonymous"),
    email: pipe(string(), trim(), toLowerCase(), email("Adresse email invalide")),
    phone: unionAsync([
      pipe(
        literal(""),
        transform(() => null),
      ),
      PhoneSchema,
      null_(),
    ]),
    departureId: number(),
    sendEmail: boolean(),
    // absent quand la demande part sans formulaire (visiteur déjà connu) => consentement non exprimé
    openTracking: optional(boolean()),
  }),
]);

export const RequestProgramOutputSchema = object({
  success: boolean(),
  email: string(),
  telephone: union([string(), null_()]),
  brochureOperationId: nullable(number()),
});

export type RequestProgramInputSchema = typeof RequestProgramInputSchema;
export type RequestProgramOutputSchema = typeof RequestProgramOutputSchema;
